<template>
  <div class="content-box">
    <el-image src="/static/imgs/xwzx.png" fit="cover" class="saveimg w-img" />
    <div class="new-box-s">
      <ul class="new-box-s-list dis" v-loading="loading">
        <li v-for="(item,index) in xwBox" :key="index">

          <router-link  style="display: block;" :to="'/news/article/' + item.id">
            <div class="dis" style="    border-bottom: 1px solid #C9CDD4;padding-bottom: 10px;">
              <div class="li-div clamp1 ">
                <p>{{item.translations.length? item.translations[0].title:''}}</p>
              </div>
              <div class="li-time">{{item.date_created.split('-')[1] + '-' + item.date_created.split('-')[2]}}</div>
            </div>
          </router-link>


        </li>
      </ul>
    </div>
    <pagesK :tootle="total" :page-size="30" @counterchange="counterchange" />
  </div>
</template>

<script>
  import pagesK from '@/components/page'
  export default {
    data() {
      return {
        total: 0,
        xwBox: [],
        loading: true
      }
    },
    mounted() {
      console.log(1)
      this.getData(1)
    },
    components: {
      pagesK
    },
    methods: {
      counterchange(e) {
        this.getData(e)
        this.goTop()
      },
      getData(page) {
        this.loading = true
        this.$request('get', this.$otapi + 'items/articles?page=' + page +
          '&limit=30&meta=*&fields=category&fields=id&fields=translations.title&filter={"status":"published"}&sort=-date_created&fields=image.filename_disk&fields=prefix&fields=date_created&sort=-id', {},
          (
            res) => {
            if (res.status == 200) {
              this.xwBox = res.data.data
              this.total = res.data.meta.filter_count
              this.loading = false
            } else {
              this.$notify.error({
                title: '错误',
                message: '请求失败，请重试！',
                position: 'top-left'
              });
            }
          })
      },
      // listDeta(val) {
      //   this.$router.push({
      //     path: '/news/article',
      //     query: {
      //       id: val.id
      //     }
      //   });
      // }
    },
    metaInfo() {
      return {
        title: '聚木网-新闻资讯'
      }
    }
  }
</script>
<style scoped>
  .new-box-s {
    width: 1200px;
    margin: 50px auto 40px auto;
  }

  .new-box-s-list {
    width: 100%;
    flex-wrap: wrap;
  }

  .new-box-s-list li {
    width: 579px;
    padding: 20px 0 0 0;
    font-weight: 400;
    font-size: 16px;
    color: #000;

    cursor: pointer;
  }

  .li-div {
    width: 504px;
  }

  .new-box-s-list li:hover {
    color: #0093FF;
  }


  .li-time {
    font-weight: 400;
    font-size: 18px;
    color: #7D7D7D;
  }

  .pagews {
    margin-bottom: 40px !important;
  }

  .new-bar-s {
    width: 8px;
    height: 8px;
    background: #1D2129;
    border-radius: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/news/index.vue